//switch visible input fields based on action input field
const filterActionEl = '#filter_action';
const emailArgumentField = '#filter_argument_email';
const folderArgumentField = '#filter_argument_folder';

//actions which require argument email input field
const emailActions = ['redirect', 'redirect_keep'];
//actions which require folder select field
const folderSelectActions = ['move'];
//all other fields do not require argument field

const qs = (selector) => document.querySelector(selector);

function hideField(field) {
    qs(field).disabled = true; //so field is not passed to POST request
    qs(field).style.display = 'none';
    qs('label[for=' + field.substring(1) + ']').style.display = 'none';
}

function showField(field) {
    qs(field).disabled = false;
    qs(field).style.display = 'inline';
    qs('label[for="' + field.substring(1) + '"]').style.display = 'inline-block';
}

function toggleArgumentFieldOnActionChange(selectedValue) {
    if (emailActions.includes(selectedValue)) {
        hideField(folderArgumentField);
        showField(emailArgumentField);
    } else if(folderSelectActions.includes(selectedValue)) {
        hideField(emailArgumentField);
        showField(folderArgumentField);
    } else {
        hideField(folderArgumentField);
        hideField(emailArgumentField);
    }
}

const initialize = () => {
    qs(filterActionEl).addEventListener("change", function (e) {

        const selectedValue = this.value;
        console.log('changed to ' + selectedValue);

        toggleArgumentFieldOnActionChange(selectedValue);
    });

    toggleArgumentFieldOnActionChange(qs(filterActionEl).value);
};

export default initialize;
